import React from "react";
import "./HowItWorks.scss";

const HowItWorks = ({ works, referAndEarnData }) => {
  return (
    <div className="howItWorksContainer">
      <img
        src={referAndEarnData.webbanner_image2}
        alt="refer-and-earn-img"
        
      />
    </div>
  );
};

export default HowItWorks;
